<template>
	<div class="courseDetail bg-[#F5F7FA]">
		<Header></Header>
		<div class="courseInfo mb-[95px]">
			<div class="2xl:w-[1140px] xl:w-[1140px] lg:container md:container mx-auto pt-[20px] ">
				<div class="text-[16px] text-[#000000] mb-[25px]">
					<label class="cursor-pointer mr-[5px]" @click="goIndex()">{{langInfo.head_home_nav}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.course_class}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.head_class_nav}}</label>><label
						class="ml-[5px]">{{courseDetail.course_name}}</label>
				</div>
				<div class="bg-white mb-[14px] shadow-02 rounded-[12px] py-[21px] px-[20px] box-border flex ">

					<el-image class="w-[375px] h-[250px] mr-[15px] rounded-[6px]" :src="courseDetail.course_logo"
						fit="cover"></el-image>
					<div class="flex-1">
						<div class="text-[20px] text-[#101010] font-semibold mb-[20px]">
							{{courseDetail.course_name}}
						</div>
						<div class="flex items-start text-[16px] text-[#101010] ">

							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in relatedSubjectList" :key="index">
									<div class="flex  mb-[8px]">
										<img src="@/static/image/icon26.png" class="mt-[4px] w-[15px] h-[15px] mr-[10px]" />
										<div class="flex-1  text-[#A2A2A2]">
											{{langInfo.study_total}}
											{{item.courseSubject.chapter_small_count}}
											{{langInfo.study_chapter}}：{{langInfo.study_total_video}}（{{item.courseSubject.chapter_count}}）；{{langInfo.test_questions}}（{{item.courseSubject.question_count}}{{langInfo.way}}）；{{langInfo.courseware}}
											({{item.courseSubject.kj_count}})&{{langInfo.notes}}{{item.courseSubject.bj_count}}
										</div>
									</div>
								</div>
								
							</div>
						</div>
						<!-- <div class="flex items-start text-[16px] text-[#101010] mb-[12px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon28.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.related_subjects}}
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in relatedSubjectList"
									:key="index">
									{{item.courseSubject.name}}<label
										v-if="index<relatedSubjectList.length - 1">、</label>
								</div>
							</div>
						</div> -->
						<!-- <div class="flex items-start text-[16px] text-[#101010] mb-[16px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon19.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.associated_certificate}}
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in certificate_list" :key="index">
									{{item.name}}<label v-if="index<certificate_list.length - 1">、</label>
								</div>
							</div>
						</div> -->
							<div class="flex items-start text-[16px] text-[#A2A2A2] mb-[11px]" v-if="user_lecturer_list.length>0">
							<div class="  flex items-center">
								<img src="@/static/image/icon34.png" class="w-[15px] h-[15px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.study_teacher_title}}：
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in user_lecturer_list"
									:key="index">
									{{item.name}}<label v-if="index<user_lecturer_list.length - 1">、</label>
								</div>
							</div>
						</div>
						<div class="flex items-center justify-between">
							<div class="flex items-center text-[14px] text-[#FF0000]">
								<!-- <img src="@/static/image/icon21.png" class="w-[20px] h-[20px] mr-[10px]" alt="" />
								{{courseDetail.count_study}}{{langInfo.people_learning}} -->
							</div>
							<div @click.stop="copyLink()"
								class="flex items-center cursor-pointer text-[#101010] text-[16px]">
								<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]" alt="" />
								{{langInfo.share}}
							</div>
							<!-- <el-popover placement="bottom" trigger="hover">
								<div class="">
									<div @click="shareQQ()"
										class="cursor-pointer flex items-center pb-[10px] box-border bB-04">
										<img src="@/static/image/icon78.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
											srcset="" /> {{langInfo['Share_QQ']}}
									</div>
									<div @click="shareWB()"
										class="cursor-pointer flex items-center pt-[10px] box-border">
										<img src="@/static/image/icon79.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
											srcset="" />
										{{langInfo['Share_Weibo']}}
									</div>
								</div>
								<div slot="reference"
									class="flex items-center cursor-pointer text-[#101010] text-[16px]">
									<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]" alt="" />
									{{langInfo.share}}
								</div>
							</el-popover> -->
						</div>
					</div>
				</div>
				<div class="flex">
					<div
						class="xl:w-[845px] xl:w-[845px] lg:w-[720px] md:w-[600px]  h-[729px] rounded-[12px] pb-[16px] box-border bg-white mr-[22px] flex flex-col">
						<div class="pt-[26px] pb-[16px] px-[20px] box-border border-01 flex items-center">
							
							
							<div @click="type=2" :class="type==2?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer text-[16px]  relative mr-[60px]">
								{{langInfo.related_subjects}}
							</div>
							<div @click="type=1" :class="type==1?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer  relative text-[16px] ">
								{{langInfo.course_details}}
							</div>
							
						</div>
						<div class="p-5 box-border flex-1" style="overflow-y: scroll;">
							<!-- 图文详情 -->
							<div class=" text-[#101010]" v-if="type==1">
								<div class="" v-if="isFinish&&courseDetail.introduce" v-html="courseDetail.introduce"
									class="whitespace-pre-wrap">
								</div>
								<emptyPage v-else-if="isFinish&&!courseDetail.introduce"
									:title="langInfo.no_brief_info">
								</emptyPage>
							</div>
							<!-- 图文详情 -->
							<!-- 关联科目 -->
							<div class="" v-else-if="type==2">
								<div class="" v-if="isFinish&&relatedSubjectList.length>0">
									<router-link :to="{path:'/subject',query: { id: item.courseSubject.id}}"
										v-for="(item,index) in relatedSubjectList" :key="index"
										class="no-underline bg-[#F7F9FC] mb-[12px] rounded-[5px] py-[20px] px-[16px] box-border flex justify-between">

										<el-image class="w-[225px] h-[150px] mr-[14px] rounded-[6px]"
											:src="item.courseSubject.image" fit="cover"></el-image>
										<div class="flex-1 min-h-[150px] text-[14px] flex flex-col  justify-between">
											<div class="mb-[10px]">
												<div class="text-[16px] text-[#000000] yw-text-cut-1 mb-[9px]">
													{{item.courseSubject.name}}
												</div>
												<div class="flex  ">
													<img src="@/static/image/icon25.png"
														class="w-[15px] h-[15px] mr-[10px]" />

													<div class="flex-1 flex flex-wrap  text-[#A2A2A2]">
														<label class="mb-[10px] "
															v-for="(ite,ind) in item.courseSubject.certificate_list">
															{{ite.name}}<label
																v-if="ind<item.courseSubject.certificate_list.length - 1">、</label>
														</label>
													</div>

												</div>
												<div class="flex  mb-[8px]">
													<img src="@/static/image/icon26.png"
														class="w-[15px] h-[15px] mr-[10px]" />
													<div class="flex-1  text-[#A2A2A2]">
														{{langInfo.study_total}}
														{{item.courseSubject.chapter_small_count}}
														{{langInfo.study_chapter}}：{{langInfo.study_total_video}}（{{item.courseSubject.chapter_count}}）；{{langInfo.test_questions}}（{{item.courseSubject.question_count}}{{langInfo.way}}）；{{langInfo.courseware}}
														({{item.courseSubject.kj_count}})&{{langInfo.notes}}{{item.courseSubject.bj_count}}
													</div>
												</div>
											<!-- 	<div class="flex  ">
													<img src="@/static/image/icon34.png"
														class="w-[15px] h-[15px] mr-[10px]" />
													<div class="flex-1  text-[#A2A2A2]">
														{{langInfo.study_teacher_title}}：{{item.courseSubject.userLecturerName}}
													</div>
												</div> -->

											</div>
											<div
												class="bg-white text-[14px]  text-[#101010] text-center w-[80px] h-[30px] leading-[30px] rounded-[4px] border border-[#bbbbbb] border-solid">
												{{langInfo.subject_info}}
											</div>
										</div>
									</router-link>
								</div>
								<emptyPage v-else-if="isFinish&&relatedSubjectList.length==0"
									:title="langInfo.no_data_available">
								</emptyPage>
							</div>
							<!-- 关联科目 -->
						</div>
					</div>
					<div class="flex-1">
						<div class="text-[16px] text-[#1C1F21] font-semibold ">
							{{langInfo.recommended_baby}}
						</div>
						<div class="">
							<router-link :to="{path:'/courseDetail',query: { id: item.id }}"
								class="no-underline flex justify-between py-[9px] box-border bB-01"
								v-for="(item,index) in recommendList" :key="index">
								<el-image class="w-[126px] h-[84px] mr-[14px] rounded-[6px]" :src="item.cover_img"
									fit="cover"></el-image>
								<div class="flex-1 h-[84px] flex justify-between flex-col">
									<div class="yw-text-cut-2 text-[12px] text-[#545C63]">
										{{item.name}}
									</div>
									<div class="text-[12px]">
										<div class="text-[#FF0000]  mb-[4px]">
											¥{{item.course_discount}}
										</div>
										<div class="flex items-center text-[#9199A1]">
											<img src="@/static/image/icon24.png" class="w-[18px] h-[15px] mr-[4px]"
												alt="" srcset="" />
											{{item.sales_volume}}{{langInfo.person_purchases}}
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},
		data() {
			return {
				type: 2, //1课程详情  2关联科目
				id: '',
				isFinish: false,
				courseDetail: {
					course_name: '',
					course_logo: '',
					course_original: '',
					course_discount: '',
					count_buy: '',
					count_study: '',
					count_view: '',
					count_favorite: '',
					count_thumbsup: '',

				},
				// 关联证书
				certificate_list: [],
				// 关联科目
				relatedSubjectList: [],
				// 讲师
				user_lecturer_list: [],

				// 推荐宝贝
				recommendList: [],
				langInfo: {},
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				if (to.query.id) {
					this.id = to.query.id
					this.get_course_detail()
				}

			}
		},
		mounted() {

			this.id = this.$route.query.id
			this.get_course_detail()


			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

		},
		methods: {
			goIndex() {
				this.$router.replace({ path: '/' });
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goCourseCenter() {
				this.$router.replace({ path: '/courseCenter' });
			},
			get_course_detail() {
				this.$api.course_detail({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.courseDetail = res.data
					document.title = res.data.course_name;
					this.certificate_list = res.data.certificate_list
					this.user_lecturer_list = res.data.user_lecturer_list
					this.relatedSubjectList = res.data.subject_list
					this.recommendList = res.data.recommend_product
					
					
					document.title=this.courseDetail.course_name

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 分享 ===复制连接
			copyLink(){
				
					const textArea = document.createElement('textarea');
					textArea.value = window.location.href;
					textArea.style.position = 'fixed'; // 避免可见区域闪烁
					document.body.appendChild(textArea);
					textArea.select();
					// 尝试复制并处理可能的异常
					const success = document.execCommand('copy');
					document.body.removeChild(textArea);
					if (success) {
						this.$message.success(this.langInfo['Copy successfully']);
					} else {
						this.$message.success("复制方法失败");
					}
				
			},
			// 分享到qq
			shareQQ() {

				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(this.courseDetail.course_name);
				const desc = encodeURIComponent(this.courseDetail.course_name);
				const summary = encodeURIComponent(this.courseDetail.course_name);
				const pics = encodeURIComponent(this.courseDetail.course_logo);

				window.open(`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&pics=${pics}`,
					'_blank');
			},
			// 分享到微博
			shareWB() {
				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(`${this.courseDetail.course_name}`);
				window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`, '_blank');
			}
		}
	}
</script>

<style scoped>
	.courseInfo {
		background-image: url('../../static/image/index05.png');
		background-size: 100% 230px;
		background-repeat: no-repeat;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 38px;
		height: 4px;
		background-color: #FF0000;
		bottom: -16px;
		left: 50%;
		transform: translateX(-50%);

	}
</style>